<template>
  <div class="container">
    <h1 class="text-center">Projects</h1>
    <hr />
    <MarkdownView class="text-center" :html="projectDesHtml" />
    <br />
    <div class="grid-3_xs-1_sm-2_md-2" v-if="projects.length">
      <div
        v-for="(project, index) in projects"
        :key="index"
        class="col center"
      >
        <a :href="project.link" target="_blank">
          <Card>
            <template #header>
              <img :src="project.img" alt="" class="project-cover" />
            </template>
            <template #title>
              <h3>{{ project.name }}</h3>
            </template>
            <template #content>
              <p>
                {{ project.des }}
              </p>
            </template>
            <template #footer>
              <a
                v-if="project.github"
                v-tooltip.bottom="'GitHub'"
                :href="project.github"
                target="_blank"
                class="github-link"
              >
                <i class="bx bxl-github"></i>
              </a>
            </template>
          </Card>
        </a>
      </div>
    </div>
    <Nothing v-else />
  </div>
</template>

<script>
import Nothing from '@/components/Nothing.vue'
import MarkdownView from '@/components/MarkdownView.vue'
import Card from 'primevue/card'
import Tooltip from 'primevue/tooltip'
let ProjectDes = null
try {
  ProjectDes = require('@/../posts/data/project-des.md')
} catch (e) {
  ProjectDes = require('@/defaults/project-des.md')
}

export default {
  name: 'ViewProjects',
  directives: {
    tooltip: Tooltip
  },
  components: {
    MarkdownView,
    Card,
    Nothing
  },
  data: function () {
    return {
      projectDesHtml: (ProjectDes && ProjectDes.html) || '',
      projects: this.getConfig('projects.json').projects
    }
  },
  mounted: function () {
    this.changeTitle('Projects')
  }
}
</script>

<style scoped>
.project-cover {
  width: 100%;
  height: 180px;
  object-fit: cover;
}

.github-link {
  display: inline-flex;
  padding: 8px;
  font-size: 20px;
  color: inherit;
}
</style>
